import config from '../../config';

export default {
  url: `${config.api.baseURL}/settings`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/settings/list.js